import { memo, useEffect } from 'react'

import { NamedItemString, getCompanyEmployeesFullNames } from 'core'

import { DefaultSelectV2 } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import './styles.less'

interface Props {
  name?: string
  excludeCompanyUserId: string | null
  onLoading?: (state: boolean) => void
}

const NewPrimaryAdminSelect = memo(({ name = 'assignAdminToId', excludeCompanyUserId, onLoading }: Props) => {
  const {
    data: employees,
    isLoading,
    sendQuery,
  } = useQueryRequestV2<NamedItemString[]>({
    initialState: [],
  })

  useEffect(() => {
    excludeCompanyUserId && sendQuery(() => getCompanyEmployeesFullNames(excludeCompanyUserId))
  }, [excludeCompanyUserId])

  useEffect(() => onLoading && onLoading(isLoading), [isLoading])

  return (
    <DefaultSelectV2
      name={name}
      className="new-primary-admin-select"
      label="Select a new Plan Admin"
      placeholder="Select an employee"
      loading={isLoading}
      items={employees}
    />
  )
})

export default NewPrimaryAdminSelect
